import './../css/index.scss';

import Grid, {GRID_CONTAINER} from './grid';
import ContactForm, {CONTACT_FORM_ID_SELECTOR} from './contact';
import MobileMenu, {NAVBAR} from './navbar';

window.addEventListener('DOMContentLoaded', () => {
  initialiseGrid();
  manageForm();
  initialiseNavbar();
});

const initialiseGrid = () => {
  const grid = document.querySelector(`.${GRID_CONTAINER}`);
  if (grid === null) {
    console.debug('No grid was found');
    return;
  }
  new Grid(grid);
};

const manageForm = () => {
  const $form = document.querySelector(CONTACT_FORM_ID_SELECTOR);
  if ($form === null) {
    return;
  }
  new ContactForm($form);
};

const initialiseNavbar = () => {
  const $navbar = document.querySelector(`.${NAVBAR}`);
  if ($navbar === null) return;
  new MobileMenu($navbar);
}
